import { ReactNode } from "react";
import { classNames } from "primereact/utils";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { StarRating } from "../../../reviews/components/StarRating/StarRating";
import { IStudioReviewModel } from "../../../reviews/models/reviewModels";
import { formatReviewDate } from "../../../reviews/utils/reviewUtility";
import styles from "./ReviewListItem.module.scss";

interface IReviewListItemProps {
  /** Undefined for the placeholder rows ItemsList shows while loading. */
  review?: IStudioReviewModel;
  /** The row's reply / hide / show buttons, built by ItemsList. */
  actionButtons?: ReactNode;
  className?: string;
}

/** One row in Administration → "Ревюта", laid out like the other administration lists. */
export const ReviewListItem = ({
  review,
  actionButtons,
  className,
}: IReviewListItemProps) => {
  if (!review) {
    return (
      <div className={classNames(styles.root, className)}>
        <div className={styles.root_main}>
          <SkeletonItem isLoading value={null} width={160} />
          <SkeletonItem isLoading value={null} width={260} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.root, className, {
        [styles.root_hidden]: review.isHidden,
      })}
    >
      <div className={styles.root_main}>
        <div className={styles.root_main_title}>
          <StarRating value={review.rating} />
          <span className={styles.root_main_title_name}>{review.reviewerName}</span>
          <RenderWhen condition={review.isHidden}>
            <span className={styles.root_main_title_badge}>Скрито</span>
          </RenderWhen>
          <span className={styles.root_main_title_date}>
            {formatReviewDate(review.createdOn)}
          </span>
        </div>

        <p
          className={classNames(styles.root_main_comment, {
            [styles.root_main_comment_empty]: !review.comment,
          })}
        >
          {review.comment || "Само оценка, без коментар"}
        </p>

        <RenderWhen condition={!!review.ownerReply}>
          <div className={styles.root_main_reply}>
            <span className={styles.root_main_reply_label}>Вашият отговор</span>
            <p className={styles.root_main_reply_text}>{review.ownerReply}</p>
          </div>
        </RenderWhen>
      </div>

      {actionButtons}
    </div>
  );
};
